"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Sign Internal OpenAPI
 * Sign Internal OpenAPI spec
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateGalleryListItemResponseToJSON = exports.TemplateGalleryListItemResponseFromJSONTyped = exports.TemplateGalleryListItemResponseFromJSON = exports.instanceOfTemplateGalleryListItemResponse = exports.attributeTypeMapTemplateGalleryListItemResponse = void 0;
var TemplateGalleryListItemResponseRelated_1 = require("./TemplateGalleryListItemResponseRelated");
var TemplateGalleryListItemResponseSigners_1 = require("./TemplateGalleryListItemResponseSigners");
var TemplateGalleryListItemResponseDescription_1 = require("./TemplateGalleryListItemResponseDescription");
var TemplateGalleryListItemResponseFieldJoined_1 = require("./TemplateGalleryListItemResponseFieldJoined");
var TemplateGalleryListItemResponsePages_1 = require("./TemplateGalleryListItemResponsePages");
var TemplateGalleryListItemResponseRules_1 = require("./TemplateGalleryListItemResponseRules");
var TemplateGalleryListItemResponseVariants_1 = require("./TemplateGalleryListItemResponseVariants");
exports.attributeTypeMapTemplateGalleryListItemResponse = [
    {
        name: "id",
        type: "number",
    },
    {
        name: "name",
        type: "string",
    },
    {
        name: "src",
        type: "Array<string>",
    },
    {
        name: "description",
        type: "Array<TemplateGalleryListItemResponseDescription>",
    },
    {
        name: "category",
        type: "string",
    },
    {
        name: "related",
        type: "Array<TemplateGalleryListItemResponseRelated>",
    },
    {
        name: "fields",
        type: "Array<TemplateGalleryListItemResponseFieldJoined>",
    },
    {
        name: "signers",
        type: "Array<TemplateGalleryListItemResponseSigners>",
    },
    {
        name: "rules",
        type: "Array<TemplateGalleryListItemResponseRules>",
    },
    {
        name: "pages",
        type: "Array<TemplateGalleryListItemResponsePages>",
    },
    {
        name: "variants",
        type: "TemplateGalleryListItemResponseVariants",
    },
];
/**
 * Check if a given object implements the TemplateGalleryListItemResponse interface.
 */
function instanceOfTemplateGalleryListItemResponse(value) {
    if (!("id" in value) || value["id"] === undefined)
        return false;
    if (!("name" in value) || value["name"] === undefined)
        return false;
    if (!("src" in value) || value["src"] === undefined)
        return false;
    if (!("description" in value) || value["description"] === undefined)
        return false;
    if (!("category" in value) || value["category"] === undefined)
        return false;
    if (!("related" in value) || value["related"] === undefined)
        return false;
    if (!("fields" in value) || value["fields"] === undefined)
        return false;
    if (!("signers" in value) || value["signers"] === undefined)
        return false;
    if (!("rules" in value) || value["rules"] === undefined)
        return false;
    if (!("pages" in value) || value["pages"] === undefined)
        return false;
    return true;
}
exports.instanceOfTemplateGalleryListItemResponse = instanceOfTemplateGalleryListItemResponse;
function TemplateGalleryListItemResponseFromJSON(json) {
    return TemplateGalleryListItemResponseFromJSONTyped(json, false);
}
exports.TemplateGalleryListItemResponseFromJSON = TemplateGalleryListItemResponseFromJSON;
function TemplateGalleryListItemResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        id: json["id"],
        name: json["name"],
        src: json["src"],
        description: json["description"].map(TemplateGalleryListItemResponseDescription_1.TemplateGalleryListItemResponseDescriptionFromJSON),
        category: json["category"],
        related: json["related"].map(TemplateGalleryListItemResponseRelated_1.TemplateGalleryListItemResponseRelatedFromJSON),
        fields: json["fields"].map(TemplateGalleryListItemResponseFieldJoined_1.TemplateGalleryListItemResponseFieldJoinedFromJSON),
        signers: json["signers"].map(TemplateGalleryListItemResponseSigners_1.TemplateGalleryListItemResponseSignersFromJSON),
        rules: json["rules"].map(TemplateGalleryListItemResponseRules_1.TemplateGalleryListItemResponseRulesFromJSON),
        pages: json["pages"].map(TemplateGalleryListItemResponsePages_1.TemplateGalleryListItemResponsePagesFromJSON),
        variants: json["variants"] == null
            ? undefined
            : (0, TemplateGalleryListItemResponseVariants_1.TemplateGalleryListItemResponseVariantsFromJSON)(json["variants"]),
    };
}
exports.TemplateGalleryListItemResponseFromJSONTyped = TemplateGalleryListItemResponseFromJSONTyped;
function TemplateGalleryListItemResponseToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        id: value["id"],
        name: value["name"],
        src: value["src"],
        description: value["description"].map(TemplateGalleryListItemResponseDescription_1.TemplateGalleryListItemResponseDescriptionToJSON),
        category: value["category"],
        related: value["related"].map(TemplateGalleryListItemResponseRelated_1.TemplateGalleryListItemResponseRelatedToJSON),
        fields: value["fields"].map(TemplateGalleryListItemResponseFieldJoined_1.TemplateGalleryListItemResponseFieldJoinedToJSON),
        signers: value["signers"].map(TemplateGalleryListItemResponseSigners_1.TemplateGalleryListItemResponseSignersToJSON),
        rules: value["rules"].map(TemplateGalleryListItemResponseRules_1.TemplateGalleryListItemResponseRulesToJSON),
        pages: value["pages"].map(TemplateGalleryListItemResponsePages_1.TemplateGalleryListItemResponsePagesToJSON),
        variants: (0, TemplateGalleryListItemResponseVariants_1.TemplateGalleryListItemResponseVariantsToJSON)(value["variants"]),
    };
}
exports.TemplateGalleryListItemResponseToJSON = TemplateGalleryListItemResponseToJSON;
